export function getRowId(cId: number) {
  return `${cId}`;
}
